export const formatSectionTitle = (sectionTitle?: string): string | undefined => sectionTitle?.toUpperCase()
